import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { ReportElementNoteDeleteInterface } from "../../../middleware/interfaces/report/report-element-note-delete-interface";

export const ReportElementNoteDelete = {
  Delete: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const reportElementNoteDeleteData: ReportElementNoteDeleteInterface =
        state.data;
      const url = "./php/report/report-element-note-deleter-proxy.php";
      await axios
        .post(url, reportElementNoteDeleteData)
        .then((response) => {
          serverResponse = response.data;
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = {
        status: "error",
        header: "error",
        message: "Something went wrong! Please contact DigitalCharcoal",
      };
    }
    return serverResponse;
  },
};
